import { normalizeText, getStatusVariantByCode, shouldDisableSignNet } from '../utils/contactsFormatters'
import { getContractTypeIconComponent } from '../utils/contactsIcons'
import { contactsActions } from '../contactsSagas'

const RESYNC_ZOHO_COOLDOWN_MS = 15 * 1000 // 15s

export const buildContactRowViewModel = ({
  row,
  t,
  actionLoadingKey,
  isGlobalLoading,
  dispatch,
  enqueue,
  flagByCountry,
  lastActionAtByContractId,
}) => {
  const hasContract = Boolean(row?.hasContract)

  const contactId = row?.contactId ?? null
  const contractId = row?.contractId ?? null

  const contactZohoId = row?.contactZohoId ?? null
  const contractZohoId = row?.contractZohoId ?? null

  const contractTypeRaw = row?.contractType ?? null
  const ContractTypeIcon = getContractTypeIconComponent(contractTypeRaw)

  const statusRaw = row?.status ?? null

  const signNetLoadingKey = contractId ? `signNet:${contractId}` : null
  const signAbandonLoadingKey = contractId ? `signAbandon:${contractId}` : null
  const resyncZohoLoadingKey = contractId ? `resyncZoho:${contractId}` : null
  const reconcileMcpSalesLoadingKey = contactZohoId ? `reconcileMcp:${contactZohoId}` : null

  const isBlockedSignNet = shouldDisableSignNet(statusRaw)

  const lastResyncAt = contractId ? lastActionAtByContractId?.[resyncZohoLoadingKey] : null
  const isResyncCooldownActive =
    typeof lastResyncAt === 'number' && Date.now() - lastResyncAt < RESYNC_ZOHO_COOLDOWN_MS

  const rowKey = [
    contactId ?? 'no-contact',
    contractId ?? 'no-contract',
    row?.contractCreatedAt ?? 'no-date',
    row?.providerName ?? 'no-provider',
  ].join('-')

  const isSignNetLoading = actionLoadingKey === signNetLoadingKey
  const isSignAbandonLoading = actionLoadingKey === signAbandonLoadingKey
  const isResyncZohoLoading = actionLoadingKey === resyncZohoLoadingKey
  const isReconcileMcpSalesLoading = actionLoadingKey === reconcileMcpSalesLoadingKey

  return {
    rowKey,

    contactIdText: normalizeText(contactId),
    contactIdTitle: contactZohoId
      ? `${t('contacts.zoho_contact_id')}: ${normalizeText(contactZohoId)}`
      : undefined,

    firstnameText: normalizeText(row?.firstname),
    lastnameText: normalizeText(row?.lastname),
    emailText: normalizeText(row?.email),

    contractIdText: normalizeText(contractId),
    contractIdTitle: contractZohoId
      ? `${t('contacts.zoho_contract_id')}: ${normalizeText(contractZohoId)}`
      : undefined,

    hasContract,

    contractTypeText: hasContract ? normalizeText(contractTypeRaw) : '-',
    ContractTypeIcon: hasContract ? ContractTypeIcon : null,

    prestationTypeText: hasContract ? normalizeText(row?.prestationType) : '-',

    statusText: hasContract ? normalizeText(statusRaw) : '-',
    statusVariant: hasContract ? getStatusVariantByCode(statusRaw) : 'neutral',

    providerExternalIdText: hasContract ? normalizeText(row?.providerExternalId) : '-',

    createdAtText: hasContract ? normalizeText(row?.contractCreatedAt) : '-',
    updatedAtText: hasContract ? normalizeText(row?.contractUpdatedAt) : '-',

    countryFlagIcon: row?.country ? flagByCountry[row.country] : null,

    isSignNetLoading,
    isSignAbandonLoading,
    isResyncZohoLoading,
    isReconcileMcpSalesLoading,

    signNetDisabled: !hasContract || isGlobalLoading || isBlockedSignNet,
    signAbandonDisabled: !hasContract || isGlobalLoading,
    resyncZohoDisabled: !hasContract || isGlobalLoading || isResyncCooldownActive,
    reconcileMcpSalesDisabled: !contactZohoId || isGlobalLoading,

    onUpdateProviderExternalId: hasContract
      ? (newValue) =>
        dispatch({
          type: contactsActions.UPDATE_PROVIDER_EXTERNAL_ID,
          payload: { contractId, providerExternalId: newValue, contractType: contractTypeRaw },
          enqueue,
          t,
        })
      : undefined,

    onSignAbandon: hasContract
      ? (reason, callback) =>
        dispatch({
          type: contactsActions.SIGN_ABANDON,
          payload: { contractId, reason },
          enqueue,
          t,
          callback,
        })
      : undefined,

    onSignNet: hasContract
      ? () =>
        dispatch({
          type: contactsActions.SIGN_NET,
          payload: { contractId },
          enqueue,
          t,
        })
      : undefined,

    onResyncZoho: hasContract
      ? () =>
        dispatch({
          type: contactsActions.RESYNC_ZOHO,
          payload: {
            contactId,
            contractId,
            contractType: contractTypeRaw,
          },
          enqueue,
          t,
        })
      : undefined,

    onReconcileMcpSales: contactZohoId
      ? () =>
        dispatch({
          type: contactsActions.RECONCILE_MCP_SALES,
          payload: { contactZohoId },
          enqueue,
          t,
        })
      : undefined,
  }
}
